import { render, staticRenderFns } from "./StudentClassAddEdit.vue?vue&type=template&id=5baf0d34"
import script from "./StudentClassAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentClassAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports